// import Button from 'components/Button';
import DataTable from 'components/DataTable';
import ListActionsWrapper from 'components/ListActionsWrapper';
import ListWrapper from 'components/ListWrapper';
import SearchInput from 'components/SearchInput';
import PageHeader from 'components/PageHeader';
import Typography from 'components/Typography';

import useEmployees from './usePrescribers';
import Pagination from 'components/Pagination';
import styles from '../Settings.module.scss';
import localStyles from './Prescribers.module.scss';
import {DataTableSchemaItem} from 'types';
import ListTabs from 'pages/UserForm/ListTabs';
import DateTimePicker from 'components/DateTimePicker';
import calendar from '../../DeliveryPlanner/icons/calendar.svg';

const SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'name',
    header: 'Prescriber Name',
    sortable: true,
  },
  {
    dataKey: 'phone',
    header: 'Phone Number',
    sortable: true,
  },
  {
    dataKey: 'npi_no',
    header: 'NPI',
    sortable: true,
  },
  {
    dataKey: 'organisation',
    header: 'Organization',
  },
  {
    dataKey: 'active',
    header: 'Status',
    // align: 'right',
  },
  {
    dataKey: 'last_prescribed_date',
    header: 'Last Prescribed Date',
    colWidth: '190px',
    sortable: true,
  },
  {
    dataKey: 'created_at',
    header: 'Sync Time',
    colWidth: '190px',
    sortable: true,
  },
  {
    dataKey: 'total_patients',
    header: 'Total Patients',
    sortable: true,
    align: 'center',
  },
  {dataKey: 'view', header: ''},
];

const TABS = [
  {title: 'All', value: 'all'},
  {title: 'To Invite', value: 'to_invite'},
  {title: 'Registered', value: 'registered'},
  {title: 'Active', value: 'active'},
];

function Employees() {
  const {
    data,
    isLoading,
    sortBy,
    sortOrder,
    onSort,
    keyWord,
    setKeyWord,
    currentPage,
    setCurrentPage,
    count,
    totalPages,
    pageSize,
    setPageSize,
    status,
    setStatus,
    onRowClick,
    metaDatas,
    setMetaDatas,
  } = useEmployees();

  return (
    <div className={styles.main_container}>
      <PageHeader>
        <Typography variant="h2">Prescribers</Typography>
        <Typography textAlign="right" variant="h4">
          Total Prescriber Count:{' '}
          {Number(count || 0).toLocaleString('en-US') || 0}
        </Typography>
      </PageHeader>

      <ListWrapper>
        <ListTabs
          tab="presriber_tab"
          tabs={TABS}
          activeTabValue={status}
          onChange={setStatus}
        />
        <ListActionsWrapper className={styles.list_header}>
          <SearchInput
            value={keyWord}
            onChange={(val) => {
              setKeyWord(val.target.value);
              setCurrentPage(1);
              sessionStorage.setItem(`search_employe`, val.target.value);
            }}
            style={{
              borderRadius: 3,
            }}
            size="md"
          />
          <div className={localStyles.dateWrapper}>
            <DateTimePicker
              icon={calendar}
              selectsRange={true}
              showTimeSelect={false}
              dateFormat="MM/dd/yy E"
              startDate={metaDatas.dataJoined?.startDate}
              endDate={metaDatas.dataJoined?.endDate}
              placeholder="Data joined"
              onChange={(data) => {
                setMetaDatas((prev: any) => ({
                  ...prev,
                  dataJoined: {
                    startDate: data[0] || undefined,
                    endDate: data[1] || undefined,
                  },
                }));
              }}
            />
          </div>
        </ListActionsWrapper>
        <DataTable
          onClick={onRowClick}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onSort={onSort}
          selectable={false}
          data={data}
          schema={SCHEMA}
          loading={isLoading}
        />
        <Pagination
          count={count || 0}
          page={currentPage}
          total={totalPages}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
      </ListWrapper>
    </div>
  );
}

export default Employees;
